import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerTituloProdutos, trazerRodapePaginasProdutos } from "../utils/utils";

const Baterias = () => {

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Trinco | Baterias";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.headerBaterias})` }}>
        <div className="servico-hero-overlay">
          <h1>Baterias</h1>
          {/* <p>Para quem procura por baterias</p> */}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Baterias e Pilhas */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carregadoresBateria} alt="" /></div>
            <h3>Relógios</h3>
            <p>Para relógios de parede e despertadores.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.bateriaRecarregavel} alt="" /></div>
            <h3>Aparelhos</h3>
            <p>Para controles, brinquedos, balanças e dispositivos eletrônicos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.bateriasTelefone} alt="" /></div>
            <h3>Telefones</h3>
            <p>Para celulares e telefones com e sem fio.</p>
          </div>


        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('baterias')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('baterias')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Baterias;